// src/components/Inventory.js
import React, { useEffect, useState } from 'react';

function Inventory() {
  const [inventory, setInventory] = useState([]);
  const [error, setError] = useState('');

  const fetchInventory = async () => {
    try {
      // Disable caching so that every poll fetches fresh data
      const response = await fetch('https://crtapp.xyz/api/inventory', { cache: 'no-store' });
      console.log('Inventory fetch status:', response.status);
      if (response.ok) {
        const data = await response.json();
        setInventory(data);
        setError('');
      } else {
        console.error('Failed to fetch inventory:', response.statusText);
        setError('Failed to load inventory. Please try again later.');
      }
    } catch (err) {
      console.error('Network error:', err);
      setError('Network or server error. Please try again later.');
    }
  };

  useEffect(() => {
    // Initial fetch
    fetchInventory();

    // Set up polling every 5 seconds (5000ms)
    const intervalId = setInterval(fetchInventory, 5000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <h1>Inventory</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <ul>
        {inventory.map((item) => (
          <li key={item.id}>
            {item.name}: {item.total_weight} lbs
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Inventory;